import React from "react";
import styled from "styled-components";
import { FlexBox } from "../../";
import { P } from "../../";
const Container = styled(FlexBox)`
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: scroll;
  width: 160px;
  padding: 0 24px;
  flex-shrink: 0;
  flex-grow: 0;
`;
const AlbumImage = styled.img`
  margin: 24px 0 0 0;
  border-radius: 4px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.8);
`;
const AlbumContainer = styled(FlexBox)`
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
`;
export const AlbumList = ({
  albums,
  onAlbumClick
}) => /*#__PURE__*/React.createElement(Container, null, albums.map(album => {
  return /*#__PURE__*/React.createElement(AlbumContainer, {
    key: album.id,
    onClick: () => onAlbumClick(album),
    "data-javelin-name": `album-click`,
    "data-javelin-meta": album.name
  }, /*#__PURE__*/React.createElement(AlbumImage, {
    width: "160px",
    src: album.images ? album.images[0].url : !!album.image ? album.image : "https://www.placecage.com/320/320"
  }), /*#__PURE__*/React.createElement(P, null, album.name));
}));